const SafeObject = {
  install (Vue, options) {
    Vue.mixin({
      filters: {
        safeObject: function (object, property) {
          if (object) {
            if (object[property]) {
              return object[property]
            }
          }
          return ''
        }
      }
    })
  }
}

export default SafeObject
